
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.324 8.225L7.346 14.7c.433.4 1.129.4 1.563 0a.96.96 0 000-1.441l-5.14-4.74h27.126C31.51 8.52 32 8.068 32 7.502c0-.566-.491-1.019-1.105-1.019H3.77l5.14-4.739a.96.96 0 000-1.441A1.16 1.16 0 008.13 0c-.278 0-.565.098-.777.302L.332 6.777c-.441.407-.441 1.056-.008 1.448z","fill":"#6E88F3"}})])
          )
        }
      }
    